import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useFilterContext } from '../../../context/FilterDetailSDSContext';

import FilterContainer from './FilterContainer/FilterContainer';
import FilterForm from './FilterForm/FilterForm';

const FilterWorkReport = ({ hide, show, isOrderByUbication }) => {
  const { formikFilters, filter } = useFilterContext();

  useEffect(() => {
    formikFilters.setValues(filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <FilterContainer onClose={hide} show={show}>
      <FilterForm isOrderByUbication={isOrderByUbication} show={show} />
    </FilterContainer>
  );
};

export default FilterWorkReport;
FilterWorkReport.propTypes = {
  hide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  isOrderByUbication: PropTypes.bool
};

FilterWorkReport.defaultProps = {
  isOrderByUbication: undefined
};
